import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ScriptToggleComponent } from '../script-toggle/script-toggle.component';

@Component({
  selector: 'lv-walk-step-photo',
  templateUrl: 'walk-step-photo.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule, ScriptToggleComponent]
})
export class WalkStepPhotoComponent {}
